import React from "react";
import Modal, {ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import Select from "../../../Components/Control/Select";
import {connect} from "react-redux";
import Hospital from "../../../Server/Hospital";
import PropTypes from "prop-types";
import Label from "../../../Components/Control/Label";
import Input from "../../../Components/Control/Input";
import Separator from "../../../Components/Control/Separator";
import Notif from "../../../Components/Notif";
import {Tool} from "../../../App";
import Resource from "../../../Resource";
import './index.css';
import ModalHospitalReserveProduct from '../ModalHospitalReserveProduct';
import MyComponent from '../../../Components/MyComponent';

class ModalHospitalAcceptRequest extends MyComponent {
    constructor(props) {
        super(props);
        props.refer.current = this;

        this.state = {
            bloodGroups: [
                {id: '', text: '...'},
                ...props.base.bloodGroups.map(item => {
                    return {id: item.id, text: item.name};
                })
            ],
            //AntiD,AntiB,AntiA,Bcell,Acell
            bloodGroupTestMap: {
                '+-++-': {id: 1, text: "A+(POS)", shortName: "A+", isNegative: false, ordering: 1},
                '++--+': {id: 2, text: "B+(POS)", shortName: "B+", isNegative: false, ordering: 2},
                '+++--': {id: 3, text: "AB+(POS)", shortName: "AB+", isNegative: false, ordering: 3},
                '+--++': {id: 4, text: "O+(POS)", shortName: "O+", isNegative: false, ordering: 4},
                '--++-': {id: 5, text: "A-(NEG)", shortName: "A-", isNegative: true, ordering: 5},
                '-+--+': {id: 6, text: "B-(NEG)", shortName: "B-", isNegative: true, ordering: 6},
                '-++--': {id: 7, text: "AB-(NEG)", shortName: "AB-", isNegative: true, ordering: 7},
                '---++': {id: 8, text: "O-(NEG)", shortName: "O-", isNegative: true, ordering: 8}
            },
            history: [],
            error: false,
            fields: {},
            data: {},
            updated: false
        };

        this.ref = {
            modal: React.createRef(),
            modalHospitalReserveProduct: React.createRef(),
            accept: React.createRef(),
            close: React.createRef(),
            patientBloodGroupId: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    validations = {
        patientBloodGroupId: x => {
            const formTypeId = this.state.data?.formTypeId;
            return formTypeId === 2 || Boolean(x && x[0]?.id) || 'گروه خونی انتخاب نشده است.'
        }
    };

    componentDidMount() {

    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {state} = this;

        return state.action !== nextState.action ||
            state.data !== nextState.data ||
            state.history !== nextState.history ||
            state.error !== nextState.error ||
            state.fields !== nextState.fields;
    }

    render() {
        const {state, props} = this;

        return <React.Fragment>
            <Modal ref={this.ref.modal}
                   name={'ModalHospitalAcceptRequest'}
                   size={'medium'}
                   error={state.error}
                   title={'ثبت گروه خون برای درخواست رسیده'}
                   onClose={_ => {
                       if (this.state.updated)
                           props.onSuccess();
                   }}>
                <ModalContent>
                    <div className={'dis-f'}>
                        <Input className={'pad-4 fb-10 fb-2x-20'} label={'نام بیمار'} value={state?.data?.patientFullName} readOnly={true}/>
                        <Input className={'pad-4 fb-10 fb-2x-20'} label={'کد‌ملی بیمار'} value={state?.data?.patientNationalCode} readOnly={true}/>
                        <Input className={'pad-4 fb-10 fb-2x-20'} label={'شماره پرونده'} value={state?.data?.patientFileCode} readOnly={true}/>
                        <Input className={'pad-4 fb-10 fb-2x-20'} label={'بخش درخواست کننده'} value={state?.data?.sectionStr} readOnly={true}/>
                        <Separator/>
                        <Select readOnly={state.action === 'RESERVE'} ref={this.ref.patientBloodGroupId} value={state.fields?.patientBloodGroupId} className={'pad-4 fb-20'} label={'گروه خون مشاهده شده'} options={state.bloodGroups} validation={this.validations.patientBloodGroupId} onChange={this.setField.bind(this, 'patientBloodGroupId')}/>
                        {state.history.length ? <Label style={{color: 'var(--goo-yel)'}}>گروه خونی ثبت شده در سامانه: {state.history[0]?.patientBlodGroupStr}</Label> : ''}
                        <div className={'examinations'}>
                            <input className={'examination-input'} type={'checkbox'} value={state.fields?.aCell} id={'aCell'} onChange={this.examinationChangeHandler.bind(this, 'aCell')}/>
                            <label className={'examination-label'} htmlFor={'aCell'}>واکنش با Acell</label>
                            <input className={'examination-input'} type={'checkbox'} value={state.fields?.bCell} id={'bCell'} onChange={this.examinationChangeHandler.bind(this, 'bCell')}/>
                            <label className={'examination-label'} htmlFor={'bCell'}>واکنش با Bcell</label>
                            <input className={'examination-input'} type={'checkbox'} value={state.fields?.antiA} id={'antiA'} onChange={this.examinationChangeHandler.bind(this, 'antiA')}/>
                            <label className={'examination-label'} htmlFor={'antiA'}>واکنش با AntiA</label>
                            <input className={'examination-input'} type={'checkbox'} value={state.fields?.antiB} id={'antiB'} onChange={this.examinationChangeHandler.bind(this, 'antiB')}/>
                            <label className={'examination-label'} htmlFor={'antiB'}>واکنش با AntiB</label>
                            <input className={'examination-input'} type={'checkbox'} value={state.fields?.antiD} id={'antiD'} onChange={this.examinationChangeHandler.bind(this, 'antiD')}/>
                            <label className={'examination-label'} htmlFor={'antiD'}>واکنش با AntiD</label>
                        </div>
                    </div>
                </ModalContent>
                <ModalControls>
                    {state.action === 'RESERVE' && <Button className={'mar-4'} theme={'yellow'} icon={Resource.IMAGE.PACK.HIGHLIGHTER.BLACK} onClick={this.reserve.bind(this)}>رزرو فرآورده</Button>}
                    {state.action === 'ACCEPT' && <Button refer={this.ref.accept} className={'mar-4'} theme={'blue'} onClick={this.acceptClickHandler.bind(this)}>تایید درخواست</Button>}
                    <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
                </ModalControls>
            </Modal>
            <ModalHospitalReserveProduct refer={this.ref.modalHospitalReserveProduct}/>
        </React.Fragment>;
    }

    acceptClickHandler() {
        if (this.validate()) {
            this.ref.accept.current.loading();
            this.setState({error: null});

            Hospital.acceptRequest({
                sectionRequestId: this.state.data?.sectionRequestId,
                patientBloodGroupId: this.state.fields?.patientBloodGroupId?.[0]?.id
            }).then(_ => {
                new Notif('با موفقیت تایید شد.').show();
                this.ref.accept.current.loading(false);
                this.setState({
                    updated: true,
                    action: this.state.data?.productTypesContain?.length ? 'RESERVE' : 'ACCEPT'
                }, () => {
                    if (!this.state.data?.productTypesContain?.length) {
                        this.close(true);
                    }
                });
            }).catch(message => {
                this.ref.accept.current.loading(false);
                this.setState({
                    error: message?.message || message,
                    history: message?.result || []
                });
                new Notif({message: message?.message || message, theme: 'error'}).show();
            });
        }
    }

    checkBloodGroup(fields) {
        const key = `${fields?.antiD ? '+' : '-'}${fields?.antiB ? '+' : '-'}${fields?.antiA ? '+' : '-'}${fields?.bCell ? '+' : '-'}${fields?.aCell ? '+' : '-'}`;
        const bloodGroup = this.state.bloodGroupTestMap[key];

        if (bloodGroup) {
            fields.patientBloodGroupId = [bloodGroup];
        } else {
            fields.patientBloodGroupId = [{id: '', text: '...'}];
        }
    }

    close() {
        this.ref.modal.current.close();

        this.props.onClose();
    }

    examinationChangeHandler(key) {
        const fields = {...this.state.fields};

        fields[key] = !Boolean(fields[key]);

        this.checkBloodGroup(fields);

        this.setState({fields});
    }

    open(data, action) {
        this.setState({
            data,
            action,
            error: null,
            fields: {},
            history: [],
            updated: false
        });

        this.ref.modal.current.open();
    }

    reserve() {
        const {state} = this;
        const bloodGroup = (state.fields?.patientBloodGroupId || [])[0];

        this.ref.modalHospitalReserveProduct.current.open({
            ...state.data,
            patientFullName: state.data?.fullName,
            patientFileCode: state.data?.fileCode,
            patientNationalCode: state.data?.nationalCode,
            patientBloodGroupStr: bloodGroup?.text,
            patientBloodGroupId: bloodGroup?.id
        });
    }

    validate() {
        const validate = Tool.validate(this.ref.patientBloodGroupId);

        if (validate !== true)
            new Notif({message: validate.message, theme: 'error'}).show();

        return validate === true;
    }
}

const mapStateToProps = state => {
    return {
        base: state.base
    };
};

export default connect(mapStateToProps)(ModalHospitalAcceptRequest);